/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum PagesPermissions {
  banks = 'manageBanks',
  commoditiesForwardCurves = 'commodity_forward_curve_widget',
  commodityMarketData = 'commodity_forward_curve_widget',
  commodityVolatility = 'commodityVolatility',
  companyCenter = 'companyPage',
  complianceCentre = 'fund_level_compliance_access',
  counterpartiesPage = 'counterpartiesPage',
  deals = 'gold_vision',
  dealsManagement = 'deals_management',
  dealsClientPricingUpdateTab = 'dealsClientPricingUpdateTab',
  entityPortfolio = 'companyEntityPage',
  fundLevelAdmin = 'fund_module_admin_page',
  cdsWidget = 'cds_widget',
  discountFactors = 'DCFX_widget',
  foreignExchangeAnalysis = 'buildFxAnalysis',
  fxForwardCurves = 'buildFXForwardRates',
  fxOptionVolatility = 'buildFxOptionVols',
  hairyChart = 'hairy_chart',
  hedgeAccounting = 'manage_hedge_accounting',
  historicalForwardCurves = 'buildHistoForwardCurves',
  historicalIrDifferentialByCurrency = 'ir_differential_widget',
  interestRateDifferentialbyCurrencyCurveTab = 'ir_differential_widget',
  interestCostCalculation = 'build_rfr_report',
  irAnalysis = 'interest_rate_analysis',
  irCapletVolatility = 'buildIrCapletVol',
  irDifferentialByCurrency = 'ir_differential_widget',
  irForwardCurves = 'buildForwardCurves',
  irMarketData = 'buildIrAnalysis',
  fxMarketData = 'buildFxAnalysis',
  journalEntries = 'manage_journal_entries',
  marketUpdateReport = 'ir_market_environment_report',
  correlatedMarketDataSimulations = 'ir_differential_widget',
  irPricer = 'insertSwapTrade',
  customPricer = 'insertSwapTrade',
  fxPricer = 'insertFxVanillaTrade',
  inflationPricer = 'inflationSwapPage',
  commodityPricer = 'commodity_pricer_access',
  debtPricer = 'Debt Pricer',
  debtManagementPlatformAccessReq = 'debtManagementPlatformAccessReq',
  reportCenter = 'reportCenter',
  riskManagementAnalysis = 'risk_mgm_analysis',
  runDeliverables = 'run_deliverables_page',
  scheduledDeliverables = 'scheduled_deliverables_page',
  securityDataDownload = 'sec_data_download',
  tradeCenter = 'trades_page',
  tradeNotification = 'trade_notification_page',
  transactionDetail = 'transactionDetail',
  users = 'manageUsers',
  userProfileAdminSection = 'userProfileAdminSection',
  resetPassword = 'resetPassword',
  createNewUser = 'addUser',
  userProfile = 'userProfile',
  settlements = 'view_settlements_history',
  sponsorPage = 'sponsorPage',
  transactionRollingTool = 'manage_fx_rolls',
  fxAnalysis = 'fx_analysis',
  exposureCapture = 'exposure_capture_page',
  exposureCalculation = 'exposure_calculation_page',
  marketDataCurvesPage = 'marketDataCurvesPage',
  marketDataWidgetsPage = 'marketDataWidgetsPage',
  transactionCostAnalysis = 'TransactionCostAnalysis',
  tradeExecutionLedger = 'tradeExecutionLedger',
  haAdministration = 'HAAdministrationPage',
  flCashConsumption = 'CashConsumptionAnalysis',
  cashCompWithCurr = 'cashCompWithCurr',
  HAOperationalDashboard = 'HAOperationalDashboard',
  sponsorDashboardAIChat = 'SponsorDashboardAIChat',
  tradeAIChatBuilder = 'tradeAIChatBuilder',
  tradeAIConfirmRead = 'tradeAIConfirmRead',
  manageAccessControl = 'manageAccessControl',
  clientApiDocs = 'ClientAPIDocs',
  marketDataPricing = 'marketDataPricing',
  buildFXForwardRates = 'buildFXForwardRates',
  bdIntelligenceHub = 'bdIntelligenceHub',
  bdAutoCaptPendingAct = 'bdAutoCaptPendingAct',
  bdPortalSIApage = 'bdPortalSIApage',
  marketDataAI = 'marketDataAI',
  // Restricted, external-facing access to Signal (the AI market-data chat).
  // Grants the page, but caps the assistant to the read-only market-data tool
  // allowlist in MarketDataAnalyzer/constants.ts (no pricing engine, no trade
  // valuation). Restriction wins over marketDataAI when a user holds both.
  externalAiMarketData = 'external_ai_market_data_user',
  fxallSessionView = 'fxallSessionView',
  fxallSessionUpdate = 'fxallSessionUpdate',
  fxallSessionDelete = 'fxallSessionDelete',
  goldVisionOpportunities = 'gold_vision_opportunities',
  sponsorPermissionManage = 'sponsorPermissionManage',
  publicHolidayCalendar = 'calendarPage',
  notificTaskProgress = 'notificTaskProgress',
  manageScheduledWidgets = 'manageScheduledWidgets',
  submitSupportRequest = 'submit_support_request',
}
